export default __webpack_public_path__ + "static/09.04-23597d0f4f672eba90954a673e21244b.png";